import { render, staticRenderFns } from "./PersonProfileMasterLocationInfoDetails.vue?vue&type=template&id=924c710c&scoped=true&"
import script from "./PersonProfileMasterLocationInfoDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterLocationInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterLocationInfoDetails.vue?vue&type=style&index=0&id=924c710c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924c710c",
  null
  
)

export default component.exports